export const Disciplines = [
    {sport_id:75,sport_name:"Swimming"},
    {sport_id:76,sport_name:"Diving"},
    {sport_id:77,sport_name:"Artistic Swimming"},
    {sport_id:78,sport_name:"Water Polo"},
]